/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/ImageTypes.yaml
/** @hidden */
export const ImageRotationValues = [
    'NONE',
    'CLOCKWISE_90',
    'CLOCKWISE_180',
    'COUNTERCLOCKWISE_90',
];
/** @hidden */
export const ImageOriginValues = [
    'TOP_LEFT',
    'TOP_RIGHT',
    'BOTTOM_LEFT',
    'BOTTOM_RIGHT',
];
//# sourceMappingURL=ImageTypes.js.map